module.exports = __webpack_public_path__ + "img/battle_rooms_mobile.a48bab18.svg";